import React, { useMemo, useRef, useState } from 'react';
import Layout from '../../../Components/layout/Layout';
import Diagram from '../../../Components/Modal/Procedure model component/Diagram';
import Decision from '../../../Components/Modal/Procedure model component/Decision';
import Step from '../../../Components/Modal/Procedure model component/Step';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { FaStar } from 'react-icons/fa6';
import { FaArrowDownLong } from 'react-icons/fa6';
import { BsFillInfoCircleFill, BsTrash } from 'react-icons/bs';
// import React, { useState } from "react";
// import Decision from "./Procedure model component/Decision";
// import Diagram from "./Procedure model component/Diagram";
// import ProcedurePrev from "./Procedure model component/ProcedurePrev";
// import Step from "./Procedure model component/Step";
import Button from '../../../Components/Butten/Button';
// import Pinkbtn from "../Butten/Pinkbtn";
import { useDispatch, useSelector } from 'react-redux';
import {
  CreateProcedureSuccess,
  RequestOfCreatingProcedure,
  CreateProcedureFailed,
  LoadProcedureOnRequest,
} from '../../../Redux/ProcedureReducer';
import { api } from '../../../Api-Endpoints/apiEndpoint';
import toast from 'react-hot-toast';
import Modal from 'react-modal';
import { useNavigate, useParams } from 'react-router-dom';
import ProcedurePrev from '../../../Components/Modal/Procedure model component/ProcedurePrev';
import JoditEditor from 'jodit-react';
import { BsExclamationDiamond } from 'react-icons/bs';
import { MdModeEdit } from 'react-icons/md';
import { FaRegCircle } from 'react-icons/fa6';
import CreateProcedurePrev from '../../../Components/Modal/Procedure model component/createPreview';
import { MdDelete } from 'react-icons/md';
import AddSchematics from '../schematics';
import AddVideos from '../videos';

const NewProcedure = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const { isCreating, isCreated, isFailed, procedures, folders } = useSelector(
    state => ({
      procedures: state.Procedure.procedures,
      folders: state.Folder.folders,
    })
  );
  const editor = useRef(null);
  const [procedureName, setProcedureName] = useState('');
  const [infoModal, setInfoModal] = useState(false);
  const [previewModel, setPreviewModel] = useState(false);
  const [setInput, setSetInput] = useState({
    stepName: '',
    decisionName: '',
    stepInfo: '',
    decisionInfo: '',
  });
  const [answerDropDown, setAnswerDropDown] = useState([]);
  const [procedure, setProcedure] = useState({
    procedureName: '',
    author: '',
    publishedAt: '',
    version: 0.1,
    isStep: false,
    isDecision: false,
    isProcedureNote: false,
    procedureNote: { title: '', procedureNoteInfo: '' },
    isProcedureNoteEdit: false,
    endProcedure: {
      stepName: '',
      stepInfo: '',
    },
    proc: [],
    images: [],
    videos: [],
    stepSafetyNotes: false,
  });

  const [formData, setFormData] = useState([
    {
      id: `step-${1}`,
      formToggle: true,
      tableOfContent: '',
      information: '',
      decisions: [
        {
          name: '',
          textContent: '',
          link: '',
        },
      ],
      images: [
        {
          name: '',
          src: '',
        },
      ],
      diagrams: [
        {
          name: '',
          src: '',
        },
      ],
    },
  ]);
  const [images, setImages] = useState([]);
  const [diagrams, setDiagrams] = useState([]);
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      placeholder: 'Start typings...',
      uploader: {
        url: `${process.env.REACT_APP_ONLINE_URL}/api/v1/get/preSigned/url`,
      },
    }),
    []
  );
  const handleNewProcInput = e => {
    const { name, value } = e.target;
    const [key1, key2] = name.split('-');
    let newUpdated;

    if (key1 == 'steps') {
      newUpdated = procedure.proc.map((_p, index) =>
        index == procedure.proc.length - 1
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                //  stepInfo: _p.steps.stepInfo
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, stepName: value }));
      // setAnswerDropDown((prev)=>([...prev,{icon:'',title:value}]))
    }
    if (key1 == 'decisions') {
      newUpdated = procedure.proc.map((_p, index) =>
        index == procedure.proc.length - 1
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                // decisionInfo: _p.decisions.decisionInfo,
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, decisionName: value }));
    }
    setProcedure({ ...procedure, proc: newUpdated });
    //  }
  };
  const handleProcStepInputInfo = e => {
    const value = e;
    let newUpdated;
    newUpdated = procedure.proc.map((_p, index) =>
      index == procedure.proc.length - 1
        ? { ..._p, steps: { title: _p?.steps?.title, stepInfo: value } }
        : _p
    );
    setSetInput(prev => ({ ...prev, stepInfo: value }));

    setProcedure({ ...procedure, proc: newUpdated });
  };

  const handleEndStep = e => {
    const value = e;
    setProcedure({
      ...procedure,
      endProcedure: {
        ...procedure.endProcedure,
        stepInfo: value,
      },
    });
  };

  const handleProcDecisionInputInfo = e => {
    const value = e;
    let newUpdated;
    newUpdated = procedure.proc.map((_p, index) =>
      index == procedure.proc.length - 1
        ? {
            ..._p,
            decisions: {
              ..._p.decisions,
              decisionInfo: value,
              answer: [{ _ans: '', _associate: '' }],
            },
          }
        : _p
    );
    setSetInput(prev => ({ ...prev, decisionInfo: value }));

    setProcedure(prev => ({ ...prev, proc: newUpdated }));
    // setProcedure({ ...procedure, proc: newUpdated });
  };
  const _onEndProcedure = () => {
    const _lastIndex = procedure.proc.length - 1;
    let updated;
    if (procedure.isDecision) {
      updated = procedure.proc.map((_, index) =>
        index == _lastIndex
          ? { ..._, decisions: { ..._.decisions, answer: [...answerDropDown] } }
          : _
      );
      setProcedure(prev => ({
        ...prev,
        isDecision: false,
        isStep: false,
        proc: updated,
      }));
      return;
    }
    const _updated = {
      ...procedure,
      procedureName,
      isStep: false,
      isDecision: false,
    };
    setProcedure(_updated);
  };
  const formToggle = (_index, state) => {
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, formToggle: state } : field
    );
    setFormData(updated);
  };

  const addForm = () => {
    const newField = {
      id: `step-${formData.length + 1}`,
      formToggle: true,
      tableOfContent: '',
      information: '',
      decisions: [
        {
          textContent: '',
          link: '',
        },
      ],
      images: [
        {
          name: '',
          src: '',
        },
      ],
      diagrams: [
        {
          name: '',
          src: '',
        },
      ],
    };
    setFormData(prev => [...prev, newField]);
  };

  const addSubField = _index => {
    const _new = formData.map((f, index) =>
      index === _index
        ? { ...f, decisions: [...f.decisions, { textContent: '', link: '' }] }
        : f
    );
    setFormData(_new);
  };

  const handleInput = (e, id) => {
    const updated = formData.map((field, index) =>
      index === id ? { ...field, [e.target.name]: e.target.value } : field
    );
    setFormData(updated);
    // console.log(updated);
  };
  const handleEditor = (e, index) => {
    const updated = formData.map((field, _index) =>
      _index === index ? { ...field, information: e } : field
    );
    setFormData(updated);
  };
  const handleInsideInput = (e, __index, index2) => {
    const _target = formData.find((f, index) => index === __index);
    const _updated = _target.decisions.map((p, _index) =>
      _index === index2 ? { ...p, [e.target.name]: e.target.value } : p
    );
    _target.decisions = _updated;
    const __updated = formData.map((d, i) =>
      i === __index ? { ...d, decisions: [..._target.decisions] } : d
    );
    setFormData(__updated);
  };

  const uploadImages = id => {
    const imgWindow = document.querySelector(`#${id}`);
    imgWindow.click();
  };
  const _saveImages = e => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
    }
    setImages([..._files]);
    setProcedure(prev => ({ ...prev, images: _files }));
  };
  const saveImages = (e, _index, _id) => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
      setImages(prev => [...prev, file[key]]);
    }
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, images: _files } : field
    );
    setFormData(updated);
  };

  const saveDiagrams = (e, _index, _id) => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
      setDiagrams(prev => [...prev, file[key]]);
    }
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, diagrams: _files } : field
    );
    setFormData(updated);
  };
  const deleteStep = _index => {
    if (formData.length !== 1) {
      const updated = formData.filter((field, index) => index !== _index);
      setFormData(updated);
    }
  };
  const onDeleteImage = (stepIndex, imgIndex) => {
    const step = formData.find((field, index) => index === stepIndex);
    const _images = step.images.filter((_img, index) => index !== imgIndex);
    step.images = _images;
    const _updatedStep = formData.map((field, index) =>
      index === stepIndex ? { ...field, images: [...step.images] } : field
    );
    setFormData(_updatedStep);
  };
  const onDeleteDiagrams = (stepIndex, diaIndex) => {
    const step = formData.find((field, index) => index === stepIndex);
    const _diagram = step.diagrams.filter((_dia, index) => index !== diaIndex);
    step.diagrams = _diagram;
    const _updatedStep = formData.map((field, index) =>
      index === stepIndex ? { ...field, diagrams: [...step.diagrams] } : field
    );
    setFormData(_updatedStep);
  };

  const _onGetAnswer = (e, index) => {
    const { name, value } = e.target;
    const updated = answerDropDown.map((_, _index) =>
      _index == index ? { ..._, [name]: value } : _
    );
    // console.log(updated)
    setAnswerDropDown(updated);
  };
  const _onGetAnswerByEdit = (e, index, __ans_index) => {
    const { name, value } = e.target;
    let _finds = procedure.proc[index];
    const _updated = _finds.decisions.answer.map((_, _index) =>
      _index == __ans_index ? { ..._, [name]: value } : _
    );

    const updated = procedure.proc.map((_, _index) =>
      _index == index
        ? { ..._, decisions: { ..._.decisions, answer: _updated } }
        : _
    );
    // _finds.decisions.answer=_updated;
    setProcedure(prev => ({ ...prev, proc: updated }));
  };

  const _onGetAssociate = (e, index) => {
    const { name, value } = e.target;
    const [type, ...rest] = value.split('-');
    const _value = rest.join('-');
    const updated = answerDropDown.map((_, _index) =>
      _index == index ? { ..._, [name]: _value, type: type } : _
    );
    setAnswerDropDown(updated);
  };
  const _onGetAssociateByEdit = (e, index, __associate_index) => {
    const { name, value } = e.target;
    const [type, ...rest] = value.split('-');
    const _value = rest.join('-');
    let _finds = procedure.proc[index];
    const _updated = _finds.decisions.answer.map((_, _index) =>
      _index == __associate_index ? { ..._, [name]: _value, type: type } : _
    );
    const updated = procedure.proc.map((_, _index) =>
      _index == index
        ? { ..._, decisions: { ..._.decisions, answer: _updated } }
        : _
    );
    setProcedure(prev => ({ ...prev, proc: updated }));
  };

  const _onFinishEdit = index => {
    console.log(answerDropDown, 'answerDropDown');
    let _finds = procedure.proc[index];
    if (_finds.isStep) {
      const updated = procedure.proc.map((_, _index) =>
        _index === index
          ? { ..._, isStepEdit: false, isDecisionEdit: false }
          : _
      );
      setProcedure({ ...procedure, proc: updated });
    }
    if (_finds.isDecision) {
      // Update `_finds` with the new answer
      if (answerDropDown[0].type) {
        _finds = {
          ..._finds,
          decisions: {
            ..._finds.decisions,
            answer: answerDropDown,
          },
        };
      }

      const updated = procedure.proc.map((_, _index) =>
        _index === index
          ? { ..._finds, isDecisionEdit: false, isStepEdit: false }
          : _
      );

      // Update the state with the modified procedure
      setProcedure({ ...procedure, proc: updated });
    }
  };

  const _onAddMoreAnswer = index => {
    const updated = procedure.proc.map((_, _index) =>
      _index == index
        ? {
            ..._,
            decisions: {
              ..._.decisions,
              answer: [..._.decisions.answer, { _ans: '', _associate: '' }],
            },
          }
        : _
    );
    setProcedure(prev => ({ ...prev, proc: updated }));
  };
  // --- refactored code here----

  // add new step
  const addNewStep = () => {
    const id = JSON.parse(localStorage.getItem('step'));
    if (id) {
      _onFinishEdit(id);
    }
    setSetInput({ stepName: '', decisionName: '' });
    setProcedure(prev => ({
      ...prev,
      isStep: true,
      isDecision: false,
      proc: [
        ...prev.proc,
        {
          isStep: true,
          isDecision: false,
          sequence: prev.proc.length + 1,
          steps: { title: '', stepInfo: '' },
          decisions: {
            title: '',
            decisionInfo: '',
            answer: [{ _ans: '', _associate: '' }],
          },
        },
      ],
    }));
  };

  const _onEditProc = index => {
    localStorage.setItem('step', JSON.stringify(index));
    setProcedure({ ...procedure, isStep: false });
    procedure.isStep = false;
    procedure.isDecision = false;

    const _finds = procedure.proc[index];
    // console.log(_finds);
    if (_finds.isStep) {
      setSetInput(prev => ({
        ...prev,
        stepName: _finds.steps.title,
        stepInfo: _finds.steps.stepInfo,
      }));
      const updated = procedure.proc.map((_, _index) =>
        _index == index
          ? { ..._, isStepEdit: true, isDecisionEdit: false }
          : { ..._, isStepEdit: false, isDecisionEdit: false }
      );
      setProcedure({ ...procedure, proc: updated });
    }
    if (_finds.isDecision) {
      setSetInput(prev => ({
        ...prev,
        decisionName: _finds.decisions.title,
        decisionInfo: _finds.decisions.decisionInfo,
      }));
      const updated = procedure.proc.map((_, _index) =>
        _index == index
          ? { ..._, isDecisionEdit: true, isStepEdit: false }
          : { ..._, isStepEdit: false, isDecisionEdit: false }
      );
      setAnswerDropDown([..._finds.decisions.answer]);
      setProcedure({ ...procedure, proc: updated });
    }
  };

  const handleDelete = index => {
    _onEndProcedure();
    setProcedure({ ...procedure, isStep: false });
    setProcedure({ ...procedure, isDecision: false });

    const updatedProc = procedure.proc.filter((_, _index) => _index !== index);

    setProcedure(prevProcedure => ({
      ...prevProcedure,
      isStep: false,
      isDecision: false,
      proc: updatedProc,
    }));

    setSetInput(prev => ({
      ...prev,
      stepName: '',
      stepInfo: '',
      decisionName: '',
      decisionInfo: '',
    }));

    setAnswerDropDown([]);
  };

  const [validate, setValidate] = useState(false);

  function closeModal() {
    setProcedureName('');
    setFormData([
      {
        id: `step-${1}`,
        formToggle: true,
        tableOfContent: '',
        information: '',
        decisions: [
          {
            name: '',
            textContent: '',
            link: '',
          },
        ],
        images: [
          {
            name: '',
            src: '',
          },
        ],
        diagrams: [
          {
            name: '',
            src: '',
          },
        ],
      },
    ]);
    setInfoModal(false);
    onGetProcedureByFolder();
  }

  const onGetProcedureByFolder = async () => {
    try {
      const id = JSON.parse(localStorage.getItem('folderId'));
      if (id) {
        // const { status, data } = await api.get(
        //   `/procedure/getProcedureByFolderId/${id}`
        // );

        const userDetails = JSON.parse(localStorage.getItem('auth'));
        const userId = userDetails?._id;
        const { status, data } = await api.get(
          // `/procedure/getProcedureByFolderId/${id}`
          `/procedure/getProcedureByFolderId?id=${id}&userId=${userId}`
        );

        if (status == 200 && data.procedures.length > 0) {
          dispatch(LoadProcedureOnRequest(data.procedures[0].procedures));
          navigate(`/procedures/${id}`);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // -- edit step name--

  const handleSequenceChange = (e, index) => {
    const value = parseInt(e.target.value) || 0;
    const updatedProcs = procedure.proc.map((proc, idx) =>
      idx === index ? { ...proc, sequence: value } : proc
    );
    setProcedure(prev => ({ ...prev, proc: updatedProcs }));
  };

  const moveProcedureUp = (index) => {
    if (index === 0) return; // Can't move first item up
    const updatedProcs = [...procedure.proc];
    [updatedProcs[index - 1], updatedProcs[index]] = [updatedProcs[index], updatedProcs[index - 1]];
    
    // Update sequence numbers
    updatedProcs.forEach((proc, idx) => {
      proc.sequence = idx + 1;
    });
    
    setProcedure(prev => ({ ...prev, proc: updatedProcs }));
  };

  const moveProcedureDown = (index) => {
    if (index === procedure.proc.length - 1) return; // Can't move last item down
    const updatedProcs = [...procedure.proc];
    [updatedProcs[index], updatedProcs[index + 1]] = [updatedProcs[index + 1], updatedProcs[index]];
    
    // Update sequence numbers
    updatedProcs.forEach((proc, idx) => {
      proc.sequence = idx + 1;
    });
    
    setProcedure(prev => ({ ...prev, proc: updatedProcs }));
  };

  const _onEditStepAndSave = (e, index) => {
    const { name, value } = e.target;
    const [key1, key2] = name.split('-');
    let newUpdated;
    if (key1 == 'steps') {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                //  stepInfo: _p.steps.stepInfo
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, stepName: value }));
      // setAnswerDropDown((prev)=>([...prev,{icon:'',title:value}]))
    }

    if (key1 == 'decisions') {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                // decisionInfo: _p.decisions.decisionInfo,
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, decisionName: value }));
    }
    setProcedure({ ...procedure, proc: newUpdated });
    //  }
  };

  // -- edit step description--

  const _onEditStepInfoAndSave = (e, index) => {
    const _finds = procedure.proc[index];
    const value = e;
    let newUpdated;
    if (_finds.isStep) {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? { ..._p, steps: { ..._p.steps, stepInfo: value } }
          : _p
      );
      setSetInput(prev => ({ ...prev, stepInfo: value }));
    }
    if (_finds.isDecision) {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? { ..._p, decisions: { ..._p.decisions, decisionInfo: value } }
          : _p
      );
      setSetInput(prev => ({ ...prev, decisionInfo: value }));
    }

    setProcedure({ ...procedure, proc: newUpdated });
  };

  // new decision
  const addNewDecision = () => {
    const id = JSON.parse(localStorage.getItem('step'));
    if (id) {
      _onFinishEdit(id);
    }

    setSetInput({ stepName: '', decisionName: '' });
    setProcedure(prev => ({
      ...prev,
      isStep: false,
      isDecision: true,
      proc: [
        ...prev.proc,
        {
          isStep: false,
          isDecision: true,
          sequence: prev.proc.length + 1,
          steps: {},
          // _answer: [{ _ans: "", _associate: "" }],
          decisions: {
            title: '',
            decisionInfo: '',
            answer: [{ _ans: '', _associate: '' }],
          },
        },
      ],
    }));
    setAnswerDropDown([{ _ans: '', _associate: '' }]);
  };

  const [schematicView, setSchematicView] = useState(false);
  const [videoView, setVideoView] = useState(false);

  const addSchematics = () => {
    setSchematicView(true);
  };

  const addVideos = () => {
    setVideoView(true);
  };

  const submit = async () => {
    const userDetails = JSON.parse(localStorage.getItem('auth'));
    if (procedure?.endProcedure?.title === '') {
      toast.error('End step title is required');
      return;
    }

    if (procedureName === '') {
      setValidate(true);
      toast.error('Procedure name is required');
      return;
    }
    setValidate(false);

    try {
      const _formData = new FormData();

      _formData.append('version', procedure.version);
      _formData.append('author', procedure.author);
      _formData.append(
        'publishedAt',
        procedure.publishedAt ? procedure.publishedAt : '2024-01-01'
      );
      _formData.append('name', procedureName);
      _formData.append('folderId', params?.id);

      _formData.append('procedureNoteTitle', procedure?.procedureNote?.title);
      _formData.append(
        'procedureNoteInfo',
        procedure?.procedureNote?.procedureNoteInfo
      );
      _formData.append('endProcedure', JSON.stringify(procedure?.endProcedure));
      _formData.append('userId', userDetails?._id);

      const allFiles = procedure?.images?.map(item => item.file);
      if (allFiles && allFiles.length > 0) {
        allFiles.forEach(file => {
          _formData.append('images', file);
        });
      }

      const allVideoFiles = procedure?.videos?.map(item => item.file);
      if (allVideoFiles && allVideoFiles.length > 0) {
        allVideoFiles.forEach(file => {
          _formData.append('images', file); // Append videos to the same 'images' field for backend processing
        });
      }

      const __procedure = procedure.proc.map((_, index) => {
        if (_.isStep) {
          return {
            sequence: _.sequence || index + 1,
            steps: _.steps,
          };
        }
        if (_.isDecision) {
          return {
            sequence: _.sequence || index + 1,
            decisions: _.decisions,
          };
        }
      });
      _formData.append('formData', JSON.stringify(__procedure));

      dispatch(RequestOfCreatingProcedure());
      const { status, data } = await api.post(
        '/procedure/procedure-create',
        _formData
      );
      if (status === 201) {
        toast.success('Procedure Created Successfully');
        dispatch(CreateProcedureSuccess(data.procedure));
        localStorage.removeItem('step');
        onGetProcedureByFolder();
      }
    } catch (error) {
      closeModal();
      dispatch(CreateProcedureFailed());
      toast.error('Error while creating procedure');
    }
  };

  // -- safety note for procedure--
  const addProcedureNote = () => {
    setProcedure(prev => ({
      ...prev,
      isProcedureNote: true,
      isProcedureNoteEdit: true,
      procedureNote: { title: '', procedureNoteInfo: '' },
    }));
  };

  const editProcedureNote = () => {
    setProcedure(prev => ({
      ...prev,
      isProcedureNote: true,
      isProcedureNoteEdit: true,
      procedureNote: { title: '', procedureNoteInfo: '' },
    }));
  };

  const deleteProcedureNote = () => {
    setProcedure(prev => ({
      ...prev,
      isProcedureNote: false,
      isProcedureNoteEdit: false,
      procedureNote: { title: '', procedureNoteInfo: '' },
    }));
  };

  const _onEndProcedureNote = () => {
    setProcedure(prev => ({
      ...prev,
      isProcedureNoteEdit: false,
      procedureNote: {
        title: procedure.procedureNote.title,
        procedureNoteInfo: procedure.procedureNote.procedureNoteInfo,
      },
    }));
  };

  const _onEditProcedureNoteTitle = e => {
    setProcedure(prev => ({
      ...prev,
      procedureNote: {
        title: e.target.value,
        procedureNoteInfo: procedure.procedureNote.procedureNoteInfo,
      },
    }));
  };

  const _onEditProcedureNoteInfo = e => {
    setProcedure(prev => ({
      ...prev,
      procedureNote: {
        title: procedure.procedureNote.title,
        procedureNoteInfo: e,
      },
    }));
  };

  // -- procedure step saftey notes---

  const addStepNote = () => {};

  // -- safety note for step--
  const addStepSafetyNote = () => {
    setProcedure(prev => ({
      ...prev,
      stepSafetyNotes: false,
      isStep: false,
      isDecision: false,
      proc: [
        ...prev.proc,
        {
          isStepNote: false,
          isStep: false,
          isDecision: false,
          steps: {
            title: '',
            stepInfo: '',
            stepSafetyNotes: true,
            safetyNote: { title: '', info: '' },
          },
          decisions: {
            title: '',
            decisionInfo: '',
            answer: [{ _ans: '', _associate: '' }],
          },
        },
      ],
    }));
  };

  return (
    <Layout heading={'Create Procedure'}>
      <div className="w-[100%]">
        <div className="procedure-info-prev flex flex-col m-2 h-[12vh] ">
          <p className="text-xl font-medium">Procedure Information:</p>

          <div className="flex w-[100%] ">
            {/* --procedure name field */}
            <div className="flex flex-col w-[50%] mt-0">
              <label>Procedure Name:*</label>
              <input
                required
                type="text"
                placeholder="Enter Procedure Name"
                className="w-[70%] p-2 border focus:border-slate-600 rounded-md outline-none"
                name={'procedureName'}
                value={procedureName}
                onChange={e => {
                  setProcedureName(e.target.value);
                  setValidate(false);
                }}
              />
            </div>

            {/* -- add step,add decision, end step */}
            <div className="flex justify-start items-center gap-5 w-[50%] ">
              <button
                onClick={addNewStep}
                className="h-[3dvh] self-end w-[7dvw] bg-[#ffffff]  border border-[#fe104d]
              rounded-md"
              >
                Add Step
              </button>

              <button
                onClick={addNewDecision}
                className="h-[3dvh] self-end w-[7dvw] bg-[#ffffff]  border border-[#fe104d]
             rounded-md"
              >
                Add Decision
              </button>

              <button
                onClick={addSchematics}
                className="h-[3dvh] self-end w-[10dvw] bg-[#ffffff]  border border-[#fe104d]
             rounded-md"
              >
                Add Schematics
              </button>

              <button
                onClick={addVideos}
                className="h-[3dvh] self-end w-[10dvw] bg-[#ffffff]  border border-[#fe104d]
             rounded-md"
              >
                Add Videos
              </button>

              <button
                onClick={addProcedureNote}
                className="h-[3dvh] self-end w-[12dvw] bg-[#ffffff]  border border-[#fe104d]
              rounded-md"
              >
                Add Safety Note
              </button>
            </div>
          </div>
        </div>
        <div className="procedure-info-prev flex flex-col m-2 h-[12vh] ">
          <div className="flex w-[100%] ">
            {/* --procedure name field */}
            <div className="flex flex-col w-[33%] mt-0">
              <label>Author</label>
              <input
                required
                type="text"
                placeholder="Enter Procedure Name"
                className="w-[70%] p-2 border focus:border-slate-600 rounded-md outline-none"
                name="author"
                value={procedure.author || ''}
                onChange={e => {
                  setProcedure({ ...procedure, author: e.target.value });
                  setValidate(false);
                }}
              />
            </div>

            {/* -- add step,add decision, end step */}
            <div className="flex flex-col w-[33%] mt-0">
              <label>Edited Date</label>
              <input
                required
                type="date"
                placeholder="Enter Edited Date"
                className="w-[70%] p-2 border focus:border-slate-600 rounded-md outline-none"
                name="publishedAt"
                defaultValue={'2001-01-01'}
                value={
                  procedure.publishedAt
                    ? procedure.publishedAt.split('T')[0]
                    : '2001-01-01'
                }
                onChange={e => {
                  setProcedure({ ...procedure, publishedAt: e.target.value });
                  setValidate(false);
                }}
              />
            </div>
            <div className="flex flex-col w-[33%] mt-0">
              <label>version</label>
              <input
                required
                type="number"
                placeholder="Enter Version"
                className="w-[70%] p-2 border focus:border-slate-600 rounded-md outline-none"
                name={'version'}
                value={procedure.version}
                onChange={e => {
                  setProcedure({ ...procedure, version: e.target.value });
                  setValidate(false);
                }}
              />
            </div>
          </div>

          {validate ? (
            <span className="pb-2 text-red-500">
              Procedure name is required.
            </span>
          ) : (
            ''
          )}
        </div>

        <div className="procedure-info-prev flex m-2 mt-6 h-[70vh] ">
          <div className="procedure-info-heading w-[100vw] h-[70vh] p-2 overflow-auto border border-slate-500">
            <div className="mb-2">
              {procedure?.isProcedureNote ? (
                <>
                  <p className="text-md font-medium m-2 mt-0 ">Safety Note:</p>

                  <div className="mt-2 border border-b-slate-300">
                    <div className="w-[100%] cursor-pointer flex flex-col justify-start gap-5">
                      <h1 className="flex gap-5 ml-5">
                        <span className="h-[30px] w-[30px] bg-black rounded-[50%] text-white flex justify-center items-center">
                          {'S'}
                        </span>
                        <span className="font-medium">
                          {procedure.procedureNote?.title === ''
                            ? 'Give this safety note a title.'
                            : procedure.procedureNote?.title}
                        </span>
                        <MdModeEdit size={20} onClick={editProcedureNote} />
                        <MdDelete size={20} onClick={deleteProcedureNote} />
                      </h1>
                      <h4
                        className="self-start"
                        dangerouslySetInnerHTML={{
                          __html: procedure.procedureNote.procedureNoteInfo,
                        }}
                      ></h4>
                    </div>

                    {procedure.isProcedureNoteEdit && (
                      <div className="w-[100%] ">
                        <input
                          type={'text'}
                          className=" w-[100%] p-1 mb-2"
                          name={'steps-title'}
                          value={procedure.procedureNote.title}
                          onChange={e => _onEditProcedureNoteTitle(e)}
                          placeholder="Give this safety note a title."
                        />
                        <JoditEditor
                          ref={editor}
                          config={config}
                          value={procedure.procedureNote.procedureNoteInfo}
                          onChange={e => _onEditProcedureNoteInfo(e)}
                        />
                        <button
                          className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
          border border-[#fe104d]
           focus:outline 
           focus:transition-all
            outline-[#fe104d] 
            text-white 
            text-center 
            cursor-pointer
            rounded-md 
            "
                          onClick={_onEndProcedureNote}
                        >
                          Finish Editing
                        </button>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                ''
              )}
            </div>

            <div className="procinfo-main">
              <div className=" w-[100%] flex gap-5 flex-col">
                {procedure.proc.map((_proc, index) =>
                  _proc?.isStep ? (
                    <div className="border border-b-slate-300">
                      <div className="w-[100%] cursor-pointer flex flex-col justify-start gap-5">
                        <h1 className="flex gap-5 ml-5">
                          <span className="h-[30px] w-[30px] bg-black rounded-[50%] text-white flex justify-center items-center">
                            {index + 1}
                          </span>
                          <span className="font-medium">
                            {_proc?.steps?.title === ''
                              ? 'Give this step a title.'
                              : _proc?.steps?.title}
                          </span>
                          <div className="flex items-center gap-2 ml-2">
                            <button
                              onClick={() => moveProcedureUp(index)}
                              disabled={index === 0}
                              className="p-1 rounded hover:bg-gray-100 disabled:opacity-50 text-gray-600"
                              title="Move up"
                            >
                              ↑
                            </button>
                            <button
                              onClick={() => moveProcedureDown(index)}
                              disabled={index === procedure.proc.length - 1}
                              className="p-1 rounded hover:bg-gray-100 disabled:opacity-50 text-gray-600"
                              title="Move down"
                            >
                              ↓
                            </button>
                          </div>
                          <MdModeEdit
                            size={20}
                            onClick={() => _onEditProc(index)}
                          />
                          <MdDelete
                            size={20}
                            onClick={() => handleDelete(index)}
                          />
                        </h1>
                        <h4
                          className="self-start"
                          dangerouslySetInnerHTML={{
                            __html: _proc.steps.stepInfo,
                          }}
                        ></h4>
                      </div>
                      {_proc.isStepEdit && (
                        <div>
                          <div className="flex items-center gap-2 mb-2">
                            <label className="text-sm font-medium">Sequence:</label>
                            <input
                              type="number"
                              className="w-20 p-1 border border-gray-300 rounded"
                              value={_proc.sequence || index + 1}
                              onChange={e => handleSequenceChange(e, index)}
                              min="1"
                              placeholder="Seq"
                            />
                          </div>
                          <input
                            type={'text'}
                            className=" w-[100%] p-1 mb-2"
                            name={'steps-title'}
                            value={setInput.stepName}
                            onChange={e => _onEditStepAndSave(e, index)}
                            placeholder="Give this step a title."
                          />
                          <JoditEditor
                            ref={editor}
                            config={config}
                            value={setInput.stepInfo}
                            onChange={e => _onEditStepInfoAndSave(e, index)}
                          />
                          <button
                            className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
                            border border-[#fe104d]
                             focus:outline 
                             focus:transition-all
                              outline-[#fe104d] 
                              text-white 
                              text-center 
                              cursor-pointer
                              rounded-md 
                              "
                            onClick={() => _onFinishEdit(index)}
                          >
                            Finish Editing
                          </button>

                          {/* <button
                            className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
                            border border-[#fe104d]
                             focus:outline 
                             focus:transition-all
                              outline-[#fe104d] 
                              text-white 
                              text-center 
                              cursor-pointer
                              rounded-md 
                              "
                            onClick={addStepSafetyNote()}
                          >
                            Add Safety Note edit
                          </button> */}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="border border-b-slate-300">
                      <div className="w-[100%] flex cursor-pointer flex-col justify-start gap-5">
                        <h1 className="flex gap-5 ml-5">
                          <label className="flex">
                            <span className="pt-3"> {index + 1}</span>
                            <BsExclamationDiamond size={30} />
                          </label>
                          <span className="font-medium">
                            {_proc?.decisions?.title === ''
                              ? 'Give this decision a title. '
                              : _proc?.decisions?.title}
                          </span>
                          <div className="flex items-center gap-2 ml-2">
                            <button
                              onClick={() => moveProcedureUp(index)}
                              disabled={index === 0}
                              className="p-1 rounded hover:bg-gray-100 disabled:opacity-50 text-gray-600"
                              title="Move up"
                            >
                              ↑
                            </button>
                            <button
                              onClick={() => moveProcedureDown(index)}
                              disabled={index === procedure.proc.length - 1}
                              className="p-1 rounded hover:bg-gray-100 disabled:opacity-50 text-gray-600"
                              title="Move down"
                            >
                              ↓
                            </button>
                          </div>
                          <MdModeEdit
                            size={20}
                            onClick={() => _onEditProc(index)}
                          />
                          <MdDelete
                            size={20}
                            onClick={() => handleDelete(index)}
                          />
                        </h1>
                        <h4
                          className="self-start"
                          dangerouslySetInnerHTML={{
                            __html: _proc?.decisions.decisionInfo,
                          }}
                        ></h4>
                      </div>
                      <h1 className="text font-medium pt-1 pb-1">ANSWERS</h1>
                      <div className="w-[100%] h-[50%] flex flex-col border border-slate-500">
                        {_proc?.decisions?.answer?.map((_, index) => (
                          <div
                            className="h-[10%] w-[100%]  flex justify-between items-center border border-b-slate-300 pl-4 pr-4 pt-1 pb-1"
                            key={index}
                          >
                            <div className="flex flex-row items-center justify-center">
                              <FaRegCircle
                                style={{
                                  color: 'grey',
                                  marginTop: '3px',
                                  marginRight: '3px',
                                }}
                                size={10}
                              />

                              <h2>
                                {/* <label className="h-[10px] w-[10px] rounded-[50%] border border-slate-400 bg-white"></label> */}
                                {_?._ans}
                              </h2>
                            </div>

                            <div>
                              {_?.type == 'steps' ? (
                                <span className="h-[20px] w-[20px] bg-black rounded-[50%] text-white flex justify-center items-center">
                                  {index + 1}
                                </span>
                              ) : (
                                <label className="flex">
                                  {index + 1}
                                  <BsExclamationDiamond size={20} />
                                </label>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      {_proc.isDecisionEdit && (
                        <div className="mt-2">
                          <div className="flex items-center gap-2 mb-2">
                            <label className="text-sm font-medium">Sequence:</label>
                            <input
                              type="number"
                              className="w-20 p-1 border border-gray-300 rounded"
                              value={_proc.sequence || index + 1}
                              onChange={e => handleSequenceChange(e, index)}
                              min="1"
                              placeholder="Seq"
                            />
                          </div>
                          <input
                            type={'text'}
                            className=" w-[100%] p-1 mb-2"
                            name={'decisions-title'}
                            value={setInput.decisionName}
                            onChange={e => _onEditStepAndSave(e, index)}
                            placeholder="Give this decision a title."
                          />
                          <JoditEditor
                            ref={editor}
                            config={config}
                            value={setInput.decisionInfo}
                            onChange={e => _onEditStepInfoAndSave(e, index)}
                          />
                          <div className="flex flex-col">
                            {_proc?.decisions.answer.map((__, _index) => (
                              <>
                                <input
                                  className=" w-[100%] p-1 mb-2 mt-2"
                                  type={'text'}
                                  placeholder="Answer description.."
                                  value={__?._ans}
                                  onChange={e =>
                                    _onGetAnswerByEdit(e, index, _index)
                                  }
                                  name="_ans"
                                />

                                <label className="font-thin">
                                  Create or select a step as target..
                                </label>
                                <select
                                  onChange={e =>
                                    _onGetAssociateByEdit(e, index, _index)
                                  }
                                  value={__?.['_associate'] || ''}
                                  className="w-[100%] p-1 mb-2"
                                  name="_associate"
                                >
                                  <option value="">Select dependency</option>

                                  {procedure.proc.map((procItem, procIndex) => (
                                    <React.Fragment key={procIndex}>
                                      {procItem.steps?.title && (
                                        <option
                                          key={`step-${procIndex}`}
                                          value={`steps-${procItem.steps.title}`}
                                        >
                                          {procItem.steps.title ||
                                            'Untitled Step'}
                                        </option>
                                      )}
                                      {procItem.decisions?.title && (
                                        <option
                                          key={`decision-${procIndex}`}
                                          value={`decisions-${procItem.decisions.title}`}
                                        >
                                          {procItem.decisions.title ||
                                            'Untitled Decision'}
                                        </option>
                                      )}
                                      <option
                                        key={`step-last`}
                                        value={`steps-endStep`}
                                      >
                                        {' '}
                                        End point{' '}
                                      </option>
                                    </React.Fragment>
                                  ))}
                                </select>
                              </>
                            ))}

                            <div className="flex flex-row items-center justify-center">
                              <button
                                className="h-[30px] w-[200px] bg-[#fe104d] ml-0 mt-2
  border border-[#fe104d]
   focus:outline 
   focus:transition-all
    outline-[#fe104d] 
    text-white 
    text-center 
    cursor-pointer
    rounded-md 
    "
                                onClick={() => _onAddMoreAnswer(index)}
                              >
                                Add more answer
                              </button>
                            </div>
                          </div>
                          <button
                            className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
  border border-[#fe104d]
   focus:outline 
   focus:transition-all
    outline-[#fe104d] 
    text-white 
    text-center 
    cursor-pointer
    rounded-md 
    "
                            onClick={() => _onFinishEdit(index)}
                          >
                            Finish Editing
                          </button>
                        </div>
                      )}
                    </div>
                  )
                )}

                {procedure.isStep && (
                  <>
                    <input
                      type={'text'}
                      className=" w-[100%] p-1 mb-2"
                      name={'steps-title'}
                      value={setInput.stepName}
                      onChange={handleNewProcInput}
                      placeholder="Give this step a title."
                    />
                    <JoditEditor
                      ref={editor}
                      config={config}
                      value={setInput.stepInfo}
                      onChange={handleProcStepInputInfo}
                    />
                    <button
                      className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
                            border border-[#fe104d]
                             focus:outline 
                             focus:transition-all
                              outline-[#fe104d] 
                              text-white 
                              text-center 
                              cursor-pointer
                              rounded-md 
                              "
                      onClick={_onEndProcedure}
                    >
                      Finish Editing
                    </button>

                    {/* <button
                      className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
                            border border-[#fe104d]
                             focus:outline 
                             focus:transition-all
                              outline-[#fe104d] 
                              text-white 
                              text-center 
                              cursor-pointer
                              rounded-md 
                              "
                      onClick={addStepSafetyNote}
                    >
                      Add Safety Note create
                    </button> */}
                  </>
                )}

                {procedure.isStepSafetyNotes && (
                  <>
                    <input
                      type={'text'}
                      className=" w-[100%] p-1 mb-2"
                      name={'steps-title'}
                      value={setInput.stepName}
                      onChange={handleNewProcInput}
                      placeholder="Give this step a title."
                    />
                    <JoditEditor
                      ref={editor}
                      config={config}
                      value={setInput.stepInfo}
                      onChange={handleProcStepInputInfo}
                    />
                    <button
                      className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
                            border border-[#fe104d]
                             focus:outline 
                             focus:transition-all
                              outline-[#fe104d] 
                              text-white 
                              text-center 
                              cursor-pointer
                              rounded-md 
                              "
                      onClick={_onEndProcedure}
                    >
                      Finish Editing
                    </button>
                  </>
                )}

                {procedure.isDecision && (
                  // className="border-2 border-blue-400 p-2"
                  <div>
                    <input
                      type={'text'}
                      className=" w-[100%] p-1 mb-2"
                      name={'decisions-title'}
                      value={setInput.decisionName}
                      onChange={handleNewProcInput}
                      placeholder="Give this decision a title."
                    />
                    <JoditEditor
                      ref={editor}
                      config={config}
                      value={setInput.decisionInfo}
                      onChange={handleProcDecisionInputInfo}
                    />

                    {/* ----decision answeres-- */}

                    <div className="flex flex-col">
                      <h4 className="font-medium">ANSWERS</h4>
                      {answerDropDown.map((__, _index) => (
                        <>
                          <input
                            className=" w-[100%] p-1 mb-2"
                            type={'text'}
                            placeholder="Answer description.."
                            onChange={e => _onGetAnswer(e, _index)}
                            name="_ans"
                          />
                          <label className="font-thin">
                            Create or select a step as target..
                          </label>
                          <select
                            onChange={e => _onGetAssociate(e, _index)}
                            className="w-[100%] p-1 mb-2"
                            name="_associate"
                            id=""
                          >
                            <option value="">Select dependency</option>
                            {procedure.proc.map((_, index) => (
                              <React.Fragment key={index}>
                                {_.steps?.title && (
                                  <option value={`steps-${_.steps.title}`}>
                                    {_.steps.title === ''
                                      ? 'Untitled Step'
                                      : _.steps.title}
                                  </option>
                                )}
                                {_.decisions?.title && (
                                  <option
                                    value={`decisions-${_.decisions.title}`}
                                  >
                                    {_.decisions.title === ''
                                      ? 'Untitled Decision'
                                      : _.decisions.title}
                                  </option>
                                )}
                                <option
                                  key={`step-last`}
                                  value={`steps-endStep`}
                                >
                                  {' '}
                                  End point{' '}
                                </option>
                              </React.Fragment>
                            ))}
                          </select>
                        </>
                      ))}
                      <div className="flex flex-row items-center justify-center">
                        <button
                          className="h-[30px] w-[200px] bg-[#fe104d] ml-0 mt-2
  border border-[#fe104d]
   focus:outline 
   focus:transition-all
    outline-[#fe104d] 
    text-white 
    text-center 
    cursor-pointer
    rounded-md 
    "
                          onClick={() =>
                            setAnswerDropDown(prev => [
                              ...prev,
                              { _ans: '', _associate: '' },
                            ])
                          }
                        >
                          Add more answer
                        </button>
                      </div>
                    </div>
                    <button
                      className="h-[30px]  w-[20dvw] ml-5 bg-[#fe104d]  mt-2 ml-0 mb-2
                            border border-[#fe104d]
                             focus:outline 
                             focus:transition-all
                              outline-[#fe104d] 
                              text-white 
                              text-center 
                              cursor-pointer
                              rounded-md 
                              "
                      onClick={_onEndProcedure}
                    >
                      Finish Editing
                    </button>
                  </div>
                )}
              </div>

              <div className="mt-9">
                <div className="border border-b-slate-300 relative">
                  <div className="w-full bg-black text-white text-center py-1 absolute top-0">
                    End Step
                  </div>

                  <div className="w-full cursor-pointer flex flex-col justify-start gap-5 pt-16 border-t border-t-slate-300">
                    <h1 className="flex gap-5 ml-5">
                      <span
                        className="h-[30px] w-[30px] bg-red-500 rounded-full text-black flex justify-center items-center"
                        aria-label="End point"
                      >
                        ES
                      </span>
                      <span className="font-medium">
                        {procedure.endProcedure.stepName}
                      </span>
                    </h1>
                    <h4 className="self-start">
                      {procedure.endProcedure.stepInfo.replace(/<\/?p>/g, '')}
                    </h4>
                  </div>

                  {/* Input and editor */}
                  <div className="mt-5">
                    <input
                      type="text"
                      className="w-full p-1 mb-2 border border-slate-300"
                      name="steps-title"
                      value={procedure.endProcedure.stepName || ''}
                      placeholder="End Point title"
                      onChange={e =>
                        setProcedure({
                          ...procedure,
                          endProcedure: {
                            ...procedure.endProcedure,
                            stepName: e.target.value,
                          },
                        })
                      }
                    />
                    <JoditEditor
                      ref={editor}
                      config={config}
                      value={procedure.endProcedure.stepInfo || ''}
                      onChange={handleEndStep}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- action btns-- */}
        <div className="submit-btn flex justify-between w-[80vw]">
          <div className="btn flex justify-start items-center gap-3">
            <button
              className="h-[30px] w-[100px] ml-5 bg-[#fe104d] 
              border border-[#fe104d]
               focus:outline 
               focus:transition-all
                outline-[#fe104d] 
                text-white 
                text-center 
                cursor-pointer
                rounded-md 
                "
              onClick={submit}
            >
              Save
            </button>
            <button
              onClick={() => setPreviewModel(true)}
              className="h-[30px] w-[100px]
             border
              border-[#fe104d]
               text-black 
               text-center
                cursor-pointer 
                focus:outline 
                focus:transition-all
                 outline-[#fe104d]
                 rounded-md
                 "
            >
              Preview
            </button>
          </div>
        </div>
      </div>

      {/* // confirmation modal-- */}
      <Modal
        isOpen={infoModal}
        style={{
          content: {
            height: '20vh',
            width: '20vw',
            transform: 'translate(200%,170%)',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
      >
        <div className="h-[20vh] w-[20vw] flex flex-col justify-center items-center gap-3">
          <div className="flex justify-center items-center gap-1">
            <BsFillInfoCircleFill color="#fe104d" size={'25px'} />
            <h3>Do you want to add more</h3>
          </div>
          <div className="flex gap-1">
            <button
              className="border border-black outline-none flex justify-center items-center h-[30px] w-[100px] rounded-md cursor-pointer"
              onClick={() => navigate('/procedures')}
            >
              No
            </button>
            <button
              onClick={closeModal}
              className="border border-black outline-none flex justify-center items-center h-[30px] w-[100px] bg-[#fe104d] rounded-md cursor-pointer text-white"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>

      {/* --preview modal--- */}
      <Modal
        isOpen={previewModel}
        onRequestClose={() => setPreviewModel(false)}
        style={{
          content: {
            height: '80vh',
            width: '85vw',
            transform: 'translate(10%,10%)',
            overflow: 'overFlowY',
            overFlowX: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
      >
        <div className="h-[100%] w-[100%] flex flex-col">
          <div className="h-[5vh] w-[100%] flex justify-end">
            <button
              onClick={() => setPreviewModel(false)}
              className="h-[30px] w-[100px] ml-5 bg-[#fe104d] 
           border border-[#fe104d]
            focus:outline 
            focus:transition-all
             outline-[#fe104d] 
             text-white 
             text-center 
             cursor-pointer
             rounded-md 
             "
            >
              Close
            </button>
          </div>
          {/* <ProcedurePrev formData={formData} /> */}

          {/* -- preview procedure-- */}
          <CreateProcedurePrev procedure={procedure} />
        </div>
      </Modal>

      {/* ---- add schematics modal-- */}

      <AddSchematics
        procedure={procedure}
        setProcedure={setProcedure}
        schematicView={schematicView}
        setSchematicView={setSchematicView}
      />

      {/* ---- add videos modal-- */}

      <AddVideos
        procedure={procedure}
        setProcedure={setProcedure}
        videoView={videoView}
        setVideoView={setVideoView}
      />
      {/* <Modal
        isOpen={schematicView}
        onRequestClose={() => setSchematicView(false)}
        style={{
          content: {
            height: "80vh",
            width: "85vw",
            transform: "translate(10%,10%)",
            overflow: "overFlowY",
            overFlowX: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
      >
        <div className="h-[100%] w-[100%] flex flex-col">
          <div className="h-[5vh] w-[100%] flex justify-end">
            <button
              onClick={() => setSchematicView(false)}
              className="h-[30px] w-[100px] ml-5 bg-[#fe104d] 
           border border-[#fe104d]
            focus:outline 
            focus:transition-all
             outline-[#fe104d] 
             text-white 
             text-center 
             cursor-pointer
             rounded-md 
             "
            >
              Close
            </button>
          </div>
          <div className="h-[10dvh] w-[100%] flex justify-start items-center gap-5 mt-6 mb-5  ">
            <p style={{ color: "#eceff4" }}>.</p>
            <input
              type="file"
              id={`images-${1}`}
              onChange={(e) => _saveImages(e)}
              hidden
              multiple
            />
            <button
              onClick={() => uploadImages(`images-${1}`)}
              className="border-2 bg-white rounded-md p-1 text-xs
                            "
            >
              Upload Image
            </button>

            <div className="w-[100%] h-[12dvh] overflow-auto">
              <table className="w-[100%] table-auto border-collapse border border-gray-300 ">
                <thead className="bg-gray-200">
                  <tr>
                    <th className=" border border-gray-300">Name</th>
                    <th className="px-4 py-2 bg-gray-200 border border-gray-300">
                      Image
                    </th>
                    <th className="px-4 py-2 bg-gray-200 border border-gray-300">
                      Delete
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {procedure.images.map((_, index) => (
                    <>
                      <tr>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          {_?.name?.substr(0, 20)}
                        </td>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          <div className="m-auto h-[50px] w-[50px] border border-black">
                            <img src={_?.src} className="h-[100%] w-[100%]" />
                          </div>
                        </td>
                        <td className="mt-5 align-center text-center flex flex-row justify-center">
                          <div
                            onClick={() =>
                              setProcedure((prev) => ({
                                ...prev,
                                images: prev.images.filter(
                                  (__, _index) => _index != index
                                ),
                              }))
                            }
                          >
                            <BsTrash color="#fe104d" />
                          </div>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal> */}
    </Layout>
  );
};

export default NewProcedure;
